export const getLocalJs = (branch) => {
    const importedFile = require(`../branches/${process.env.REACT_APP_API_ENV}/${branch}/index.js`);
    return importedFile;
}